import { useMemo, useState } from 'react'
import type { SupplierFilters, SupplierRow } from './SupplierList.types'

export function useSupplierFilters(rows: SupplierRow[], allApprovedRows: SupplierRow[]) {
  const [filters, setFilters] = useState<SupplierFilters>({
    supplier: '',
    oem: '',
    type: '',
    blanket: false,
  })

  const filteredRows = useMemo(() => {
    const supplier = filters.supplier.trim()
    const oem = filters.oem.trim()
    const type = filters.type.trim()
    const blanketOnly = filters.blanket

    return rows
      .filter(r => {
        const matchesSupplier = !supplier || r.name === supplier
        const matchesType = !type || r.type.trim().toLowerCase() === type.toLowerCase()
        const matchesBlanket = !blanketOnly || r.blanket === true
        const matchesOem = !oem || r.authorizedOems.some(o => o === oem)

        return matchesSupplier && matchesType && matchesBlanket && matchesOem
      })
      .sort((a, b) => a.name.localeCompare(b.name))
  }, [rows, filters])

  const supplierOptions = useMemo(() => {
    return Array.from(new Set(rows.map(r => r.name))).sort()
  }, [rows])

  const typeOptions = useMemo(() => {
    return Array.from(new Set(allApprovedRows.map(r => r.type.trim()).filter(Boolean))).sort()
  }, [allApprovedRows])

  return {
    filters,
    setFilters,
    filteredRows,
    supplierOptions,
    typeOptions,
  }
}
